import React, { useId } from "react";
import { BaseUrl } from "../../helper/BaseUrl";

export default function CampusToCorporateSection({ aiData, onAction }) {
  if (!aiData?.campusToCorporate) return null;
  return (
    <section className="campus-to-corporate-section">
      <div className="container">
        <div className="row align-items-center campus-to-corporate-row">
          <div className="col-lg-6">
          <img src={`${BaseUrl}${aiData?.campusToCorporate?.image}`}  className="img-responsive campus-to-corporate-image"  alt={aiData?.campusToCorporate?.title}   width="736"
              height="940"
              loading="lazy"/>
          </div>
          <div className="col-lg-6">
            <div className="campus-to-corporate-content">
              <span className="main-title campus-to-corporate-eyebrow">{aiData?.campusToCorporate?.eyebrow}</span>
              <h2 className="heading">{aiData?.campusToCorporate?.title}</h2>
              <p className="campus-to-corporate-subtitle"><em>{aiData?.campusToCorporate?.subtitle}</em></p>
              <ul className="campus-to-corporate-points">
                {aiData?.campusToCorporate?.items.map((item, index) => (
                  <li key={index}>
                    <h3>{item?.title}</h3>
                    <p>{item?.description}</p>
                  </li>
                ))}
              </ul>
              <button type="button" className="default-btn" onClick={onAction}>
                {aiData?.campusToCorporate?.buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
